import { render, staticRenderFns } from "./notificar_por_whatsapp_button.vue?vue&type=template&id=2cc1d4d6&lang=pug&"
import script from "./notificar_por_whatsapp_button.vue?vue&type=script&lang=js&"
export * from "./notificar_por_whatsapp_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports